import './bundle'
import lscache from 'lscache'

window.BBCL.mixins.push({
    computed: {
        automaticDarkMode: {
            get() {
                return this.$store.state['BBCL'].automaticDarkMode
            },
            set(value) {
                this.$store.commit('BBCL/SET_AUTOMATIC_DARK_MODE', value)
            }
        },
        darkMode: {
            get() {
                return this.$store.state['BBCL'].darkMode
            },
            set(value) {
                this.$store.commit('BBCL/SET_DARK_MODE', value)
            }
        },
        // INCLUSIVO
        openMenuAccesible: {
            get() {
                return this.$store.state['BBCL'].openMenuAccesible
            },
            set(value) {
                this.$store.commit('BBCL/SET_OPEN_MENU_ACCESIBLE', value)
            }
        },
        highContrast: {
            get() {
                return this.$store.state['BBCL'].highContrast
            },
            set(value) {
                this.$store.commit('BBCL/SET_HIGH_CONTRAST', value)
            }
        },
        modoAccesible: {
            get() {
                return this.$store.state['BBCL'].modoAccesible
            },
            set(value) {
                this.$store.commit('BBCL/SET_MODO_ACCESIBLE', value)
            }
        },
        // AGRANDAR Y ACHICAR TEXTO
        textLevel1: {
            get() {
                return this.$store.state['BBCL'].texLevel1
            },
            set(value) {
                this.$store.commit('BBCL/SET_TEXT_LEVEL1', value)
            }
        },

        textLevel2: {
            get() {
                return this.$store.state['BBCL'].textLevel2
            },
            set(value) {
                this.$store.commit('BBCL/SET_TEXT_LEVEL2', value)
            }
        }
    },
    methods: {
        goUp() {
            try {
                window.scroll({
                    top: 0,
                    behavior: 'smooth'
                })
            } catch {
                window.scroll(0, 0)
            }
        },
        markRead(index) {
            this.$store.commit('BBCL/MARK_READED', index)
        }
    }
})

window.BBCL.plugins.push((Vue, store) => {
    let automaticDarkModeTimeoutId

    function fetchNews() {
        Vue.axios.get(`https://www.biobiochile.cl/static/news.json?t=${Date.now()}`).then(({ data }) => {
            store.commit('BBCL/PROCESS_NEWS', data)
        })
    }

    function tryToSetDarkMode() {
        const now = new Date()

        if (now.getHours() < 7 || now.getHours() >= 21) {
            if (!document.body.classList.contains('dark-mode')) {
                document.body.classList.add('dark-mode')
            }
        } else {
            if (document.body.classList.contains('dark-mode')) {
                document.body.classList.remove('dark-mode')
            }
        }
    }

    function automaticDarkModeTimeout() {
        tryToSetDarkMode()
        automaticDarkModeTimeoutId = setTimeout(automaticDarkModeTimeout, 60000)
    }

    function startAutomaticDarkMode() {
        clearTimeout(automaticDarkModeTimeoutId)

        tryToSetDarkMode()

        automaticDarkModeTimeoutId = setTimeout(automaticDarkModeTimeout, (60 - new Date().getSeconds()) * 1000)
    }

    function stopAutomaticDarkMode() {
        clearTimeout(automaticDarkModeTimeoutId)
        if (!store.state.BBCL.darkMode && document.body.classList.contains('dark-mode')) {
            document.body.classList.remove('dark-mode')
        }
    }

    function articleToNew(article, markAsNew = false) {
        return {
            id: article.ID,
            title: article.post_title,
            url: article.post_URL,
            timestamp: article.post_date_timestamp,
            dateHour: article.post_hour,
            new: markAsNew
        }
    }

    store.registerModule('BBCL', {
        namespaced: true,
        state() {
            return {
                darkMode: lscache.get('darkMode'),
                automaticDarkMode: lscache.get('automaticDarkMode'),
                // ALTO CONTRASTE
                highContrast: lscache.get('highContrast') || false,
                // ACCESIBLE
                modoAccesible: lscache.get('modoAccesible') || false,
                // AGRANDAR TEXTO
                textLevel: lscache.get('textLevel') ?? 0,
                // BOTON ACCESIBLE
                openMenuAccesible: lscache.get('openMenuAccesible') || false,
                news: lscache.get('news') || [],
                lastView: lscache.get('lastView') || Date.now()
            }
        },
        getters: {
            notReaded(state) {
                let notReaded = String(
                    state.news.reduce((notReaded, article) => (article.new ? notReaded + 1 : notReaded), 0)
                )

                if (notReaded > 9) {
                    notReaded = '9+'
                } else if (notReaded === '0') {
                    notReaded = ''
                }

                return notReaded
            },
            notificationCount(state) {
                let notificationCount = String(
                    state.news.reduce(
                        (accumulator, article) =>
                            article.timestamp * 1000 > state.lastView ? accumulator + 1 : accumulator,
                        0
                    )
                )

                if (notificationCount > 9) {
                    notificationCount = '9+'
                } else if (notificationCount === '0') {
                    notificationCount = ''
                }

                return notificationCount
            }
        },
        mutations: {
            SET_DARK_MODE(state, value) {
                lscache.set('darkMode', value)
                state.darkMode = value

                if (value) {
                    state.automaticDarkMode = false
                    lscache.set('automaticDarkMode', false)
                    state.highContrast = false
                    lscache.set('highContrast', false)
                }

                if (window.ga) {
                    if (value) {
                        window.ga('send', 'event', 'Modo Oscuro', 'Activado')
                    } else {
                        window.ga('send', 'event', 'Modo Oscuro', 'Desactivado')
                    }
                }
            },
            SET_AUTOMATIC_DARK_MODE(state, value) {
                lscache.set('automaticDarkMode', value)
                state.automaticDarkMode = value

                if (value) {
                    state.darkMode = false
                    lscache.set('darkMode', false)
                }

                if (window.ga) {
                    if (value) {
                        window.ga('send', 'event', 'Modo Oscuro', 'Activado (Automático)')
                    } else {
                        window.ga('send', 'event', 'Modo Oscuro', 'Desactivado (Automático)')
                    }
                }
            },

            // INCLUSIVO
            SET_HIGH_CONTRAST(state, value) {
                lscache.set('highContrast', value)
                state.highContrast = value

                if (value) {
                    state.darkMode = false
                    lscache.set('darkMode', false)
                    state.automaticDarkMode = false
                    lscache.set('automaticDakMode', false)
                }
            },
            SET_MODO_ACCESIBLE(state, value) {
                lscache.set('modoAccesible', value)
                state.modoAccesible = value
            },
            SET_TEXT_LEVEL(state, value) {
                state.textLevel = value
                lscache.set('textLevel', value)
            },
            SET_OPEN_MENU_ACCESIBLE(state, value) {
                state.openMenuAccesible = value
                lscache.set('openMenuAccesible', value)
            },
            PROCESS_NEWS(state, articles) {
                if (state.news.length === 0) {
                    state.news = articles.map(article => articleToNew(article))
                    lscache.set('news', state.news)
                } else {
                    const news = articles
                        .map(article => articleToNew(article, true))
                        .filter(article => article.timestamp > state.news[0].timestamp)

                    if (news.length) {
                        state.news = news.concat(state.news).slice(0, 10)
                        lscache.set('news', state.news)
                    }
                }
            },
            MARK_READED(state, newIndex) {
                if (state.news[newIndex]) {
                    Vue.set(state.news[newIndex], 'new', false)
                    lscache.set('news', state.news)
                }
            },
            CLEAR_NOTIFICATION_COUNT(state) {
                state.lastView = Date.now()
                lscache.set('lastView', state.lastView)
            }
        }
    })

    store.watch(
        state => state.BBCL.darkMode,
        isDark => {
            if (isDark) {
                document.body.classList.add('dark-mode')
                document.body.classList.remove('high-contrast')
            } else {
                document.body.classList.remove('dark-mode')
            }
        },
        { immediate: true }
    )

    store.watch(
        state => state.BBCL.automaticDarkMode,
        isAuto => {
            if (isAuto) {
                startAutomaticDarkMode()
                document.body.classList.remove('high-contrast')
            } else {
                stopAutomaticDarkMode()
            }
        },
        { immediate: true }
    )

    // INCLUSIVO
    store.watch(
        state => state.BBCL.openMenuAccesible,
        isMenuAccesible => {
            if (isMenuAccesible) {
                document.body.classList.add('open-menu-accesible')
            } else {
                document.body.classList.remove('open-menu-accesible')
            }
        }
    )

    store.watch(
        state => state.BBCL.highContrast,
        isHC => {
            if (isHC) {
                document.body.classList.add('high-contrast')
                document.body.classList.remove('dark-mode')
            } else {
                document.body.classList.remove('high-contrast')
            }
        },
        { immediate: true }
    )

    // ACCESIBLE
    store.watch(
        state => state.BBCL.modoAccesible,
        isMA => {
            if (isMA) {
                document.body.classList.add('modo-accesible')
            } else {
                document.body.classList.remove('modo-accesible')
            }
        },
        { immediate: true }
    )

    store.watch(
        state => state.BBCL.darkMode && state.BBCL.modoAccesible,
        isAccesibleDark => {
            if (isAccesibleDark) {
                document.body.classList.add('modo-accesible-dark')
                document.body.classList.remove('dark-mode')
                document.body.classList.remove('modo-accesible')
            } else {
                document.body.classList.remove('modo-accesible-dark')
                document.body.classList.add('modo-accesible')
                document.body.classList.add('dark-mode')
            }
        }
    )

    // CONTROL DE CLASES
    store.watch(
        state => [state.BBCL.darkMode, state.BBCL.highContrast, state.BBCL.modoAccesible],
        ([isDark, isHC, isMA]) => {
            const body = document.body
            body.classList.remove(
                'dark-mode',
                'high-contrast',
                'modo-accesible',
                'modo-accesible-dark',
                'modo-accesible-hc'
            )
            if (isDark && isMA) {
                body.classList.add('modo-accesible-dark')
            } else if (isHC && isMA) {
                body.classList.add('modo-accesible-hc')
            } else if (isDark) {
                body.classList.add('dark-mode')
                store.commit('BBCL/SET_TEXT_LEVEL', 0)
            } else if (isHC) {
                body.classList.add('high-contrast')
                store.commit('BBCL/SET_TEXT_LEVEL', 0)
            } else if (isMA) {
                body.classList.add('modo-accesible')
            } else {
                store.commit('BBCL/SET_TEXT_LEVEL', 0)
            }
        },
        { immediate: true }
    )

    store.watch(
        state => state.BBCL.textLevel,
        level => {
            document.body.classList.remove('text-level-0', 'text-level-1', 'text-level-2', 'text-level-3')
            document.body.classList.add(`text-level-${level}`)
        },
        { immediate: true }
    )
    fetchNews()
    setInterval(fetchNews, 60000)
})
